export default __webpack_public_path__ + "static/media/CultureSummary.bc8bac62.svg";